import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/headerExpanded.js';
import Store from 'store/store';
import { accessNested, joinClasses } from 'utils/utils';
import Socials from 'components/bolt/socials/socials';

import s from 'components/bolt/header/headerExpanded.sss';

export default class HeaderExpanded extends BaseComp.default {
	renderSocial() {
		const socials = accessNested(this.props, 'appData.header.powsterHeader.follow');
		const isIOS = accessNested(this.props, 'client.isIOS', false);

		if (!socials) {
			return;
		}
		return (
			<Socials
				class={joinClasses(s.socials, !isIOS && s.notIOS)}
				socials={socials}
				navOpen={this.props.navOpen}
				key="socials"
			/>
		);
	}

}